import type { OriginationView } from "@shared/originationConstants";

export interface OriginationDescription {
  kind: string;
  primary: string;
  secondary: string | null;
  href: string | null;
}

const GONE = "A contact no longer in the CRM";

/** One display rule for every surface that shows where a company came from. */
export function describeOrigination(o: OriginationView): OriginationDescription {
  switch (o.sourceType) {
    case "coi_referral":
      return { kind: "COI", primary: o.contactName ?? GONE, secondary: o.contactCompanyName, href: o.contactId ? `/coi/${o.contactId}` : null };
    case "advocate_referral":
      return { kind: "Advocate", primary: o.contactName ?? GONE, secondary: o.contactCompanyName, href: o.contactId ? `/contacts/${o.contactId}` : null };
    case "buyer_intro":
      return { kind: "Buyer", primary: o.contactName ?? GONE, secondary: o.contactCompanyName, href: o.contactId ? `/contacts/${o.contactId}` : null };
    case "partner_network":
      return { kind: "Network", primary: o.userName ?? "A partner", secondary: null, href: null };
    case "inbound_website":
      return { kind: "Website", primary: `Valuation${o.occurredOn ? " · " + o.occurredOn : ""}`, secondary: o.submissionHeadline, href: "/website/valuations" };
    case "outbound":
      return o.outreachListId
        ? { kind: "Outbound", primary: o.outreachListName ?? "Outreach list", secondary: null, href: `/mass-outreach?list=${o.outreachListId}` }
        : { kind: "Outbound", primary: o.detail === "research" ? "Research" : o.detail ?? "Outbound", secondary: null, href: null };
    case "event":
      return { kind: "Event", primary: o.detail ?? "Event", secondary: null, href: null };
    case "other":
    default:
      return { kind: "Other", primary: o.detail ?? "Not recorded", secondary: null, href: null };
  }
}
